export function registerContactActions({ ui, preferences }) {
  const translate = (sk, en) => preferences.currentLang === 'en' ? en : sk;
  let feedbackTimer;

  function openChoice(title, value, phoneLink) {
    const dialog = document.getElementById('contact-choice');
    const input = document.getElementById('contact-choice-value');
    const dial = document.getElementById('contact-choice-dial');
    document.getElementById('contact-choice-title').textContent = title;
    input.value = value;
    dial.hidden = !phoneLink;
    if (phoneLink) dial.href = phoneLink;
    else dial.removeAttribute('href');
    if (!dialog.open) dialog.showModal();
    return input;
  }

  ui.handlePhoneClick = function handlePhoneClick(phone, link) {
    if (window.matchMedia('(max-width: 980px), (pointer: coarse)').matches) {
      openChoice(translate('Telefón', 'Phone'), phone, link.href);
      document.querySelector('#contact-choice [data-action="copy-contact-value"]').focus();
    } else {
      return ui.copyToClipboard(phone);
    }
  };

  ui.copyToClipboard = async function copyToClipboard(text) {
    const dialog = document.getElementById('contact-choice');
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      // Keep the actual value selected for manual copying if both clipboard APIs are denied.
      const input = openChoice(
        translate('Skopírujte označený údaj', 'Copy the selected value'),
        text,
        dialog.open ? document.getElementById('contact-choice-dial').getAttribute('href') : null,
      );
      input.focus();
      input.select();
      try {
        if (!document.execCommand('copy')) return;
      } catch {
        return;
      }
    }
    if (dialog.open) dialog.close();
    const status = document.getElementById('contact-copy-status');
    status.textContent = translate('Skopírované do schránky', 'Copied to clipboard');
    clearTimeout(feedbackTimer);
    feedbackTimer = setTimeout(() => { status.textContent = ''; }, 2400);
  };
}
